/**
 * AUIPivotReact.js v1.2.::RELEASE_DATE
 * Based on AUIPivot v::VERSION
 * Copyright © AUISoft Co., Ltd.
 * www.auisoft.net
 */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

// 프로젝트 경로에 맞게 바꾸세요
import '../AUIPivot/AUIPivot';
import '../AUIPivot//messages/AUIPivot.messages.kr';
import '../AUIPivot/AUIPivotLicense';
import '../AUIPivot/AUIPivot_style.css';

// 이 아래 소스는 절대 수정하지 마세요.
const $ag = typeof window === 'undefined' ? {} : window.AUIPivot;
let uuid = 0;
class AUIPivot extends React.Component {
	constructor(props) {
		super(props);
		this.uuid = uuid.toString();
		uuid += 1;
		this.id = 'aui-pivot-wrap-' + (this.props.name !== '' ? this.props.name : this.uuid);
		this.pid = '#' + this.id;
		this.timerId = null;
	}

	componentDidMount() {
		if (this.props.createOnMounted) {
			$ag.create(this.pid, this.props.pivotProps);
			this.__setupGlobalReisze();
		}
	}

	componentWillUnmount() {
		this.__resetGlobalReisze();
		if ($ag.isCreated(this.pid)) $ag.destroy(this.pid);
	}

	render() {
		return <div id={this.id}></div>;
	}

	__setupGlobalReisze() {
		if (!this.props.autoResize) return;
		window.addEventListener('resize', this.__globalResizeHandler.bind(this));
	}

	__resetGlobalReisze() {
		if (!this.props.autoResize) return;
		window.removeEventListener('resize', this.__globalResizeHandler.bind(this));
	}

	__globalResizeHandler(event) {
		const that = this;
		if (that.timerId !== null) {
			clearTimeout(that.timerId);
		}
		that.timerId = setTimeout(function () {
			if ($ag.isCreated(that.pid)) {
				$ag.resize(that.pid);
			}
		}, that.resizeDelayTime);
	}

	create(props) {
		$ag.create(this.pid, props);
		this.__setupGlobalReisze();
		return this.pid;
	}
	bind(name, func) {
		return $ag.bind.call($ag, this.pid, arguments[0], arguments[1]);
	}
	changeHeatmapColors(dataField, opName, colors) {
		$ag.changeHeatmapColors.call($ag, this.pid, arguments[0], arguments[1], arguments[2]);
	}
	clearFilterAll() {
		$ag.clearFilterAll.call($ag, this.pid);
	}
	clearPivot() {
		$ag.clearPivot.call($ag, this.pid);
	}
	clearPivotFieldsAll() {
		$ag.clearPivotFieldsAll.call($ag, this.pid);
	}
	clearSortingAll() {
		$ag.clearSortingAll.call($ag, this.pid);
	}
	closeFilterLayer() {
		$ag.closeFilterLayer.call($ag, this.pid);
	}
	collapseAll() {
		$ag.collapseAll.call($ag, this.pid);
	}
	collapseAllColumns() {
		$ag.collapseAllColumns.call($ag, this.pid);
	}
	createPivotPanel(props) {
		return $ag.createPivotPanel.call($ag, this.pid, arguments[0]);
	}
	destroy() {
		$ag.destroy.call($ag, this.pid);
	}
	destroyPivotPanel(flag) {
		$ag.destroyPivotPanel.call($ag, this.pid, arguments[0]);
	}
	expandAll() {
		$ag.expandAll.call($ag, this.pid);
	}
	expandAllColumns() {
		$ag.expandAllColumns.call($ag, this.pid);
	}
	exportToCsv(props) {
		$ag.exportToCsv.call($ag, this.pid, arguments[0]);
	}
	exportToPdf(props) {
		$ag.exportToPdf.call($ag, this.pid, arguments[0]);
	}
	exportToTxt(props) {
		$ag.exportToTxt.call($ag, this.pid, arguments[0]);
	}
	exportToXlsx(exportWithStyle, props) {
		$ag.exportToXlsx.call($ag, this.pid, arguments[0], arguments[1]);
	}
	getAliasByDataField(dataField) {
		return $ag.getAliasByDataField.call($ag, this.pid, arguments[0]);
	}
	getCellDetailList(rowIndex, columnIndex) {
		return $ag.getCellDetailList.call($ag, this.pid, arguments[0], arguments[1]);
	}
	getColumnFields() {
		return $ag.getColumnFields.call($ag, this.pid);
	}
	getColumnFormatString() {
		return $ag.getColumnFormatString.call($ag, this.pid);
	}
	getColumnIndexByDataField(dataField) {
		return $ag.getColumnIndexByDataField.call($ag, this.pid, arguments[0]);
	}
	getColumnInfoList() {
		return $ag.getColumnInfoList.call($ag, this.pid);
	}
	getColumnItemByDataField(dataField) {
		return $ag.getColumnItemByDataField.call($ag, this.pid, arguments[0]);
	}
	getColumnLayout() {
		return $ag.getColumnLayout.call($ag, this.pid);
	}
	getDataFieldByColumnIndex(idx) {
		return $ag.getDataFieldByColumnIndex.call($ag, this.pid, arguments[0]);
	}
	getDataFieldList(all) {
		return $ag.getDataFieldList.call($ag, this.pid, arguments[0]);
	}
	getDimensionValues(rowIndex, columnIndex) {
		return $ag.getDimensionValues.call($ag, this.pid, arguments[0], arguments[1]);
	}
	getDisplayOrderRules() {
		return $ag.getDisplayOrderRules.call($ag, this.pid);
	}
	getExceptSumRowFields() {
		return $ag.getExceptSumRowFields.call($ag, this.pid);
	}
	getFieldAlias() {
		return $ag.getFieldAlias.call($ag, this.pid);
	}
	getFilterFields() {
		return $ag.getFilterFields.call($ag, this.pid);
	}
	getFitColumnSizeList(fitToGrid) {
		return $ag.getFitColumnSizeList.call($ag, this.pid, arguments[0]);
	}
	getFooterData() {
		return $ag.getFooterData.call($ag, this.pid);
	}
	getItemByRowIndex(rowIndex) {
		return $ag.getItemByRowIndex.call($ag, this.pid, arguments[0]);
	}
	getPivotData() {
		return $ag.getPivotData.call($ag, this.pid);
	}
	getPivotPanelState() {
		return $ag.getPivotPanelState.call($ag, this.pid);
	}
	getProp(name) {
		return $ag.getProp.call($ag, this.pid, arguments[0]);
	}
	getProperty(name) {
		return $ag.getProperty.call($ag, this.pid, arguments[0]);
	}
	getRowCount() {
		return $ag.getRowCount.call($ag, this.pid);
	}
	getRowFields() {
		return $ag.getRowFields.call($ag, this.pid);
	}
	getRowFormatString() {
		return $ag.getRowFormatString.call($ag, this.pid);
	}
	getSourceData() {
		return $ag.getSourceData.call($ag, this.pid);
	}
	getSourceItemByValue(dataField, value) {
		return $ag.getSourceItemByValue.call($ag, this.pid, arguments[0], arguments[1]);
	}
	getSourceItemsByValue(dataField, value) {
		return $ag.getSourceItemsByValue.call($ag, this.pid, arguments[0], arguments[1]);
	}
	getTreeTotalDepth() {
		return $ag.getTreeTotalDepth.call($ag, this.pid);
	}
	getValueFields() {
		return $ag.getValueFields.call($ag, this.pid);
	}
	hidePivotPanel() {
		$ag.hidePivotPanel.call($ag, this.pid);
	}
	isAvailabePdf() {
		return $ag.isAvailabePdf.call($ag, this.pid);
	}
	isAvailableLocalDownload() {
		return $ag.isAvailableLocalDownload.call($ag, this.pid);
	}
	isCreated() {
		return $ag.isCreated.call($ag, this.pid);
	}
	isCreatedPivotPanel() {
		return $ag.isCreatedPivotPanel.call($ag, this.pid);
	}
	movePivotPanel(x, y) {
		$ag.movePivotPanel.call($ag, this.pid, arguments[0], arguments[1]);
	}
	removeAjaxLoader() {
		$ag.removeAjaxLoader.call($ag, this.pid);
	}
	removeInfoMessage() {
		$ag.removeInfoMessage.call($ag, this.pid);
	}
	resize(w, h) {
		$ag.resize.call($ag, this.pid, arguments[0], arguments[1]);
	}
	resizePivotPanel(width, height) {
		return $ag.resizePivotPanel.call($ag, this.pid, arguments[0], arguments[1]);
	}
	setColumnFields(columnFields) {
		return $ag.setColumnFields.call($ag, this.pid, arguments[0]);
	}
	setColumnFormatString(arr) {
		$ag.setColumnFormatString.call($ag, this.pid, arguments[0]);
	}
	setColumnSizeList(value) {
		return $ag.setColumnSizeList.call($ag, this.pid, arguments[0]);
	}
	setDataType(typeObj) {
		$ag.setDataType.call($ag, this.pid, arguments[0]);
	}
	setDateFormatString(formatArr) {
		return $ag.setDateFormatString.call($ag, this.pid, arguments[0]);
	}
	setDateInputFormat(formatString) {
		return $ag.setDateInputFormat.call($ag, this.pid, arguments[0]);
	}
	setDateTypeField(fieldName) {
		return $ag.setDateTypeField.call($ag, this.pid, arguments[0]);
	}
	setDisplayOrderRules(orders) {
		$ag.setDisplayOrderRules.call($ag, this.pid, arguments[0]);
	}
	setExceptFields(fields) {
		return $ag.setExceptFields.call($ag, this.pid, arguments[0]);
	}
	setExceptSumRowFields(arr) {
		$ag.setExceptSumRowFields.call($ag, this.pid, arguments[0]);
	}
	setFieldAlias(aliasInfo) {
		$ag.setFieldAlias.call($ag, this.pid, arguments[0]);
	}
	setFieldOrder(arr) {
		$ag.setFieldOrder.call($ag, this.pid, arguments[0]);
	}
	setFilterFields(filterFields) {
		return $ag.setFilterFields.call($ag, this.pid, arguments[0]);
	}
	setGridData(gridData) {
		return $ag.setGridData.call($ag, this.pid, arguments[0]);
	}
	setHeatmapColors(dataField, opName, colors) {
		$ag.setHeatmapColors.call($ag, this.pid, arguments[0], arguments[1], arguments[2]);
	}
	setMaxWidthOfRowFields(obj) {
		return $ag.setMaxWidthOfRowFields.call($ag, this.pid, arguments[0]);
	}
	setProp(obj, value) {
		$ag.setProp.call($ag, this.pid, arguments[0], arguments[1]);
	}
	setProperty(obj, value) {
		return $ag.setProperty.call($ag, this.pid, arguments[0], arguments[1]);
	}
	setRowDimStyleFunction(func) {
		$ag.setRowDimStyleFunction.call($ag, this.pid, arguments[0]);
	}
	setRowFields(rowFields) {
		return $ag.setRowFields.call($ag, this.pid, arguments[0]);
	}
	setRowFormatString(arr) {
		$ag.setRowFormatString.call($ag, this.pid, arguments[0]);
	}
	setSelectionByIndex(rowIndex, columnIndex) {
		return $ag.setSelectionByIndex.call($ag, this.pid, arguments[0], arguments[1]);
	}
	setSorting(sortingInfoArr, onlyLastDepthSorting) {
		return $ag.setSorting.call($ag, this.pid, arguments[0], arguments[1]);
	}
	setValueFields(valueFields) {
		return $ag.setValueFields.call($ag, this.pid, arguments[0]);
	}
	showAjaxLoader() {
		$ag.showAjaxLoader.call($ag, this.pid);
	}
	showInfoMessage(msgHTML) {
		$ag.showInfoMessage.call($ag, this.pid, arguments[0]);
	}
	showItemsOnDepth(depth) {
		return $ag.showItemsOnDepth.call($ag, this.pid, arguments[0]);
	}
	showPivotPanel() {
		$ag.showPivotPanel.call($ag, this.pid);
	}
	unbind(name, func) {
		return $ag.unbind.call($ag, this.pid, arguments[0], arguments[1]);
	}
	unload() {
		$ag.unload.call($ag, this.pid);
	}
	updatePivot() {
		$ag.updatePivot.call($ag, this.pid);
	}
}

AUIPivot.propTypes = {
	name: PropTypes.string,
	autoResize: PropTypes.bool,
	resizeDelayTime: PropTypes.number,
	pivotProps: PropTypes.object,
	createOnMounted: PropTypes.bool
};

AUIPivot.defaultProps = {
	name: '',
	autoResize: true,
	resizeDelayTime: 300,
	pivotProps: {},
	createOnMounted: true
};

export default AUIPivot;

export const apUtils = {
	releaseDate: $ag.releaseDate,
	version: $ag.version
};
